import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { useSettings } from "@/context/SettingsContext";
import { LayoutDashboard, Package, ShoppingCart, Tags, Settings, LogOut, Store } from "lucide-react";

const nav = [
  { to: "/admin", label: "Dashboard", icon: LayoutDashboard, end: true },
  { to: "/admin/products", label: "Products", icon: Package },
  { to: "/admin/orders", label: "Orders", icon: ShoppingCart },
  { to: "/admin/categories", label: "Categories", icon: Tags },
  { to: "/admin/settings", label: "Settings", icon: Settings },
];

export default function AdminLayout() {
  const { logout } = useAuth();
  const { settings } = useSettings();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#F4F2EE] font-body md:flex">
      <aside className="flex flex-col bg-brand-green text-cream md:min-h-screen md:w-64">
        <div className="flex items-center gap-3 p-6">
          {settings.logo && <img src={settings.logo} alt="logo" className="h-10 w-10 rounded-full object-contain" />}
          <div>
            <p className="font-heading text-xl text-white">{settings.business_name || "Taanya"}</p>
            <p className="text-xs text-cream/60">Admin Panel</p>
          </div>
        </div>
        <nav className="flex gap-1 overflow-x-auto px-3 pb-3 md:flex-col md:overflow-visible">
          {nav.map((n) => (
            <NavLink
              key={n.to}
              to={n.to}
              end={n.end}
              data-testid={`admin-nav-${n.label.toLowerCase()}`}
              className={({ isActive }) =>
                `flex items-center gap-3 whitespace-nowrap rounded-xl px-4 py-2.5 text-sm font-medium transition-colors ${
                  isActive ? "bg-brand text-white" : "text-cream/80 hover:bg-white/10"
                }`
              }
            >
              <n.icon className="h-4 w-4" /> {n.label}
            </NavLink>
          ))}
        </nav>
        <div className="mt-auto space-y-1 p-3">
          <button
            data-testid="admin-view-site"
            onClick={() => navigate("/")}
            className="flex w-full items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-cream/80 hover:bg-white/10"
          >
            <Store className="h-4 w-4" /> View Site
          </button>
          <button
            data-testid="admin-logout"
            onClick={() => {
              logout();
              navigate("/admin/login");
            }}
            className="flex w-full items-center gap-3 rounded-xl px-4 py-2.5 text-sm text-cream/80 hover:bg-white/10"
          >
            <LogOut className="h-4 w-4" /> Logout
          </button>
        </div>
      </aside>
      <main className="flex-1 p-5 md:p-8">
        <Outlet />
      </main>
    </div>
  );
}
